import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Link,
} from "@mui/material";
import { useAuth } from "../../../../context";
import useFetchObjects from "../../../../api/useFetchObjects";
import useUpdate from "../../../../api/useUpdate";
import { useTranslation } from "react-i18next";

const EditExpenseDialog = ({ open, onClose, expense }) => {
  const { t } = useTranslation();
  const auth = useAuth();
  const token = auth?.user?.token;
  const [formData, setFormData] = useState({
    amount: "",
    expenseType: "",
    // expenseSource: "",
    description: "",
    date: "",
    time: "",
    file: null,
  });

  const { data: expenseTypes } = useFetchObjects(
    ["expense-types"],
    "expense-types/",
    token
  );

  // const { data: expenseSource } = useFetchObjects(
  //   ["expense-sources"],
  //   "expense-sources/",
  //   token
  // );

  const { handleUpdate } = useUpdate("expenses", token);

  useEffect(() => {
    if (expense) {
      setFormData({
        amount: expense.amount,
        expenseType: expense.expenseType,
        // expenseSource: expense.expenseSource,
        description: expense.description,
        date: expense.date,
        time: expense.time,
        file: null,
      });
    }
  }, [expense]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: files ? files[0] : value,
    }));
  };

  const handleSave = () => {
    const updatedData = new FormData();
    updatedData.append("amount", formData.amount);
    updatedData.append("expenseType", formData.expenseType);
    // updatedData.append("expenseSource", formData.expenseSource);
    updatedData.append("description", formData.description);
    updatedData.append("date", formData.date);
    updatedData.append("time", formData.time);

    if (formData.file) {
      updatedData.append("file", formData.file);
    }

    handleUpdate(expense.id, updatedData);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t("finance.editExpense")}</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          margin="normal"
          label="Amount"
          name="amount"
          value={formData.amount}
          onChange={handleChange}
        />
        <FormControl fullWidth margin="normal">
          <InputLabel>{t("finance.expenseType")}</InputLabel>
          <Select
            name="expenseType"
            value={formData.expenseType}
            onChange={handleChange}
          >
            {expenseTypes?.map((type) => (
              <MenuItem key={type.id} value={type.id}>
                {type.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {/* <FormControl fullWidth margin="normal">
          <InputLabel>{t("finance.expenseSource")}</InputLabel>
          <Select
            name="expenseSource"
            value={formData.expenseSource}
            onChange={handleChange}
          >
            {expenseSource?.map((type) => (
              <MenuItem key={type.id} value={type.id}>
                {type.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl> */}
        <TextField
          fullWidth
          margin="normal"
          label={t("finance.description")}
          name="description"
          value={formData.description}
          onChange={handleChange}
          multiline
          rows={4}
        />
        <TextField
          fullWidth
          margin="normal"
          label={t("finance.date")}
          name="date"
          type="date"
          value={formData.date}
          onChange={handleChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          fullWidth
          margin="normal"
          label={t("finance.time")}
          name="time"
          type="time"
          value={formData.time}
          onChange={handleChange}
          InputLabelProps={{ shrink: true }}
        />

        {/* File Upload */}
        {expense.file && (
          <Link
            href={expense.file}
            target="_blank"
            rel="noopener"
            sx={{ display: "block", marginTop: 2 }}
          >
            {t("finance.downloadCurrentFile")}
          </Link>
        )}
        <TextField
          fullWidth
          margin="normal"
          type="file"
          name="file"
          onChange={handleChange}
          InputLabelProps={{ shrink: true }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          {t("finance.cancel")}
        </Button>
        <Button
          onClick={handleSave}
          color="primary"
          sx={{ margin: "0px 10px" }}
        >
          {t("finance.save")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditExpenseDialog;
